import { useCallback, useState } from "react";

import { useDeveloperTool } from "~/components/admin/DeveloperMenu";

import { CacheManagerDialog } from "./CacheManagerDialog";

export function WithCacheManagerDialog(props: { children?: React.ReactNode }) {
  const { children } = props;

  const [open, setOpen] = useState(false);

  useDeveloperTool({
    key: "cache-manager",
    enable: true,
    action: useCallback(() => setOpen(true), []),
  });

  return (
    <>
      <CacheManagerDialog open={open} onClose={() => setOpen(false)} />
      {children}
    </>
  );
}
